/** True when the page was loaded via browser refresh (F5). */
export function isPageReload() {
  const entry = performance.getEntriesByType("navigation")[0];
  return entry?.type === "reload";
}

/** F5 on homepage should land on hero, not a saved section hash/scroll. */
export function resetHomeScrollOnReload() {
  if (!isPageReload()) return false;
  if (window.location.pathname !== "/") return false;

  const { pathname, search } = window.location;
  if (window.location.hash) {
    window.history.replaceState(null, "", `${pathname}${search}`);
  }
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  return true;
}
